var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 15,
    viewBox: "0 0 59 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54935 0L0 14.4935H7.84049L8.81248 12.1826H11.0342L12.0062 14.4935H20.6364V12.7298L21.4054 14.4935H25.8696L26.6386 12.6925V14.4935H44.587L46.7695 12.2426L48.813 14.4935L58.0317 14.5121L51.4617 7.2872L58.0317 0H48.956L46.8315 2.20926L44.8523 0H25.3268L23.6501 3.74089L21.9341 0H14.11V1.70371L13.2396 0H6.54935ZM33.3516 2.0581H43.6584L46.8108 5.46325L50.0648 2.0581H53.2172L48.4275 7.28517L53.2172 12.452H49.9218L46.7695 9.00729L43.4989 12.452H33.3516V2.0581ZM35.8968 6.10993V4.21141V4.2096H42.328L45.1342 7.24582L42.2036 10.2986H35.8968V8.22599H41.5197V6.10993H35.8968ZM8.06644 2.0581H11.8883L16.2324 11.8862V2.0581H20.4191L23.7745 9.10481L26.8668 2.0581H31.0326V12.4581H28.4978L28.4771 4.30873L24.7817 12.4581H22.5142L18.7981 4.30873V12.4581H13.5836L12.595 10.1266H7.25402L6.26748 12.4561H3.47358L8.06644 2.0581ZM8.16599 7.97119L9.92562 3.81773L11.6832 7.97119H8.16599Z",
    fill: "#1F72CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLogo);
export default __webpack_public_path__ + "static/media/AMEX-logo.147999b7966f57cff5544da0e6873080.svg";
export { ForwardRef as ReactComponent };